import * as actionTypes from '../types/semiProducts';

export function getSemiProducts(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCTS,
    payload
  };
}

export function getSemiProductsSuccess(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCTS_SUCCESS,
    payload
  };
}

export function getSemiProductsFail(payload) {
  return {
    type: actionTypes.GET_SEMI_PRODUCTS_FAIL,
    payload
  };
}
